module.exports = __webpack_public_path__ + "static/img/pricenb.1e35097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pricenb.jpg
// module id = mvAU
// module chunks = 1